import { render, staticRenderFns } from "./CompetitorsTable.vue?vue&type=template&id=603908bc&scoped=true&"
import script from "./CompetitorsTable.vue?vue&type=script&lang=js&"
export * from "./CompetitorsTable.vue?vue&type=script&lang=js&"
import style0 from "./CompetitorsTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CompetitorsTable.vue?vue&type=style&index=1&id=603908bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603908bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VDataTable,VIcon,VRow,VTooltip})
